















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AppBtn extends Vue {
  @Prop({ type: [String, Object] })
  private to?: string | {}

  @Prop({ required: false })
  private color?: string

  @Prop() private size?: string

  @Prop({ default: false, required: false })
  private block?: boolean

  @Prop({ default: false, required: false })
  private loading?: boolean

  @Prop({ default: 'button', required: false })
  private type?: string

  @Prop({ default: false, required: false })
  private disabled?: boolean

  private click(ev: Event) {
    if (this.loading) {
      ev.preventDefault()
      return false
    }

    this.$emit('click', ev)
  }
}
